module.exports = __webpack_public_path__ + "static/requests-vacations-6e62fc9c46d4c96c7103e3d0335d3868.png";